import { render } from "./HomeModule.vue?vue&type=template&id=0a74819a"
import script from "./HomeModule.vue?vue&type=script&lang=js"
export * from "./HomeModule.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__